<template>
    <a-layout style="min-height: 100vh;">
        <UserHead />
        <a-layout>
            <a-layout-header style="padding: 0; background: #fff; border-bottom: 1px solid #f0f0f0;">
                <HeadTop />
            </a-layout-header>
            <a-layout-content class="page-content" style="padding: 24px; background: #f5f7fa;">
                <div class="page-inner">
                    <a-card :bordered="false" class="carmine-card">
                        <a-tabs v-model:activeKey="el_tab_active" @change="handleClick">
                            <a-tab-pane key="first" tab="使用卡密">
                                <a-input v-model:value="form.kami" placeholder="请输入卡密" style="margin-bottom: 12px;" />
                                <a-input v-model:value="form.host" placeholder="授权字段(ip/域名等)"
                                    style="margin-bottom: 12px;" />
                                <a-input v-model:value="form.email" placeholder="绑定邮箱" style="margin-bottom: 12px;" />
                                <a-card class="decription" :bordered="false" size="small">
                                    <div>
                                        <strong
                                            style="color: #1677ff;">授权字段：</strong>不同插件要求的授权字段是不一样的，可能要求授权域名，可能要求授权ip，也可能要求授权手机号等等
                                        <br><strong
                                            style="color: #1677ff;">绑定邮箱：</strong>授权将会绑定到此邮箱上面，若邮箱未注册易售SUP授权站则会自动注册，默认密码
                                        123456，将会自动绑定上级用户为卡密的创建者
                                    </div>
                                </a-card>
                                <div class="action-wrap">
                                    <a-button type="primary" @click="useCarmine()">使用卡密</a-button>
                                </div>
                            </a-tab-pane>

                            <a-tab-pane key="second" tab="验证卡密">
                                <a-input v-model:value="form.kami" placeholder="请输入卡密" style="margin-bottom: 12px;" />
                                <div v-if="form.isVerify" class="verify-result">
                                    <div class="verify-title">卡密信息</div>
                                    <div class="verify-row">
                                        <span class="verify-label">卡密：</span>
                                        <span>{{ showCarmine.carmine }}</span>
                                    </div>
                                    <div class="verify-row">
                                        <span class="verify-label">状态：</span>
                                        <span :style="{ color: showCarmine.state == 1 ? '#52c41a' : '#ff4d4f' }">{{
                                            getCarmineSate(showCarmine.state) }}</span>
                                    </div>
                                    <div class="verify-row">
                                        <span class="verify-label">类型：</span>
                                        <span>{{ getCarmineType(showCarmine.timeUnit) }}</span>
                                    </div>
                                    <div class="verify-row" v-if="showCarmine.state == 1">
                                        <span class="verify-label">创建者：</span>
                                        <span>{{ showCarmine.createUid }}</span>
                                    </div>
                                    <div class="verify-row" v-else>
                                        <span class="verify-label">使用者：</span>
                                        <span>{{ showCarmine.usedUid }}</span>
                                    </div>
                                    <div class="verify-row">
                                        <span class="verify-label">插件：</span>
                                        <span>{{ showCarmine.pluginName }}</span>
                                    </div>
                                    <div class="verify-row">
                                        <span class="verify-label">功能版本：</span>
                                        <span>{{ showCarmine.versionName }}</span>
                                    </div>
                                </div>
                                <a-card v-else class="decription" :bordered="false" size="small">
                                    <div>本功能是用于查询卡密状态，查询是否被使用等！不会影响卡密有效性，请放心查询</div>
                                </a-card>
                                <div class="action-wrap">
                                    <a-button type="primary" @click="verifyCarmine()">查询卡密</a-button>
                                </div>
                            </a-tab-pane>
                        </a-tabs>
                    </a-card>
                </div>
            </a-layout-content>
        </a-layout>
    </a-layout>
</template>

<style lang="scss" scoped>
.page-inner {
    max-width: 720px;
    margin: 0 auto;
}

.carmine-card {
    border-radius: 8px;

    :deep(.ant-card-body) {
        padding: 24px;
    }

    :deep(.ant-tabs-nav) {
        margin-bottom: 20px;
    }

    :deep(.ant-tabs-tab) {
        font-size: 14px;
        padding: 0 16px;
    }

    :deep(.ant-tabs-ink-bar) {
        background: #1677ff;
    }

    :deep(.ant-input) {
        width: 100%;
    }
}

.decription {
    border-radius: 8px;
    margin-top: 4px;

    :deep(.ant-card-body) {
        padding: 12px 14px;
        font-size: 13px;
        color: #595959;
        line-height: 1.7;
    }
}

.action-wrap {
    margin-top: 16px;
    text-align: center;
}

.verify-result {
    background: #fafafa;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
}

.verify-title {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 10px;
    color: rgba(0, 0, 0, 0.88);
}

.verify-row {
    display: flex;
    padding: 4px 0;
    font-size: 13px;
}

.verify-label {
    color: rgba(0, 0, 0, 0.45);
    min-width: 70px;
}
</style>

<script>
import { defineComponent } from 'vue';
import axios from 'axios';
import { message } from 'ant-design-vue'
import UserHead from '@/components/UserHead.vue'
import HeadTop from '@/components/UserHeadTop.vue'
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    name: 'CarmineUse',
    components: {
        UserHead,
        HeadTop
    },
    data() {
        return {
            form: {
                host: "",
                kami: "",
                email: "",
                isVerify: false
            },
            showCarmine: {},
            includes_data: [],
            el_tab_active: "first"
        }
    },
    methods: {
        handleClick(key) {
            this.form.isVerify = false
            this.el_tab_active = key
        },
        useCarmine() {
            axios.post(baseURL + "/carmine/use", {
                carmine: this.form.kami,
                host: this.form.host,
                email: this.form.email
            }, {
                timeout: 30000,
                headers: { 'token': localStorage.getItem("token") }
            }).then(res => {
                if (res.data.code == 200) {
                    message.success(res.data.msg)
                } else {
                    message.error(res.data.msg)
                }
            }).catch(err => {
                message.error('请求失败：' + err.message)
                console.log(err)
            })
        },
        verifyCarmine() {
            axios.get(baseURL + "/carmine/verify?kami=" + this.form.kami, {
                timeout: 30000,
            }).then(res => {
                if (res.data.code == 200) {
                    message.success(res.data.msg)
                    this.showCarmine = res.data.data.kami
                    this.form.isVerify = true
                } else {
                    message.error(res.data.msg)
                }
            }).catch(err => {
                message.error('请求失败：' + err.message)
                console.log(err)
            })
        },
        getCarmineSate(state) {
            if (state == 1) return "未使用"
            else if (state == 0) return "已被使用"
            else if (state == -1) return "已被禁用"
        },
        getCarmineType(type) {
            if (type == "day") return "天"
            else if (type == "month") return "月"
            else if (type == "year") return "年"
            else if (type == "forever") return "永久"
            else return "未知"
        }
    }
})
</script>
